module.exports = __webpack_public_path__ + "c243735327562c889c8e62ac6894ebf7.MP3";